import { Skeleton } from "@/components/ui/skeleton";

export function TestListSkeleton() {
  return (
    <div className="flex flex-col">
      {/* 데스크톱: 테이블 헤더 */}
      <div className="hidden sm:flex items-center gap-3 px-4 h-12 bg-muted sticky top-0 z-10">
        <Skeleton className="h-4 w-[120px] shrink-0" />
        <Skeleton className="h-4 w-20 flex-1" />
        <Skeleton className="h-4 w-[100px] shrink-0" />
      </div>

      {/* 데스크톱: 테이블 행 */}
      {Array.from({ length: 6 }, (_, i) => (
        <div
          key={`desktop-${i}`}
          className="hidden sm:flex items-center gap-3 px-4 py-4 border-b border-muted last:border-b-0"
        >
          <Skeleton className="h-4 w-[120px] shrink-0" />
          <Skeleton className="h-5 w-48 flex-1" />
          <Skeleton className="h-7 w-16 rounded-md shrink-0" />
        </div>
      ))}

      {/* 모바일: 카드형 */}
      <div className="flex flex-col gap-4 sm:hidden">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={`mobile-${i}`} className="relative rounded-lg bg-card p-4 flex flex-col">
            <div className="flex items-center justify-center p-2">
              <Skeleton className="h-5 w-16" />
            </div>
            <div className="flex items-center justify-center p-2">
              <Skeleton className="h-6 w-47" />
            </div>
            <Skeleton className="absolute top-4 right-4 h-7 w-16 rounded-md" />
          </div>
        ))}
      </div>
    </div>
  );
}
